import CollapsibleNavSection from './CollapsibleNavSection'
import { HomeNavThreadList } from './HomeNavThreadList'

export default function HomeNavPinnedProjectsSection({
  projects,
  selectedProjectId,
  onSelectProject,
  onRenameProject,
}) {
  return (
    <CollapsibleNavSection title="Pinned Project" defaultExpanded>
      <HomeNavThreadList
        threads={projects}
        selectedThreadId={selectedProjectId}
        onSelectThread={onSelectProject}
        onRenameThread={onRenameProject}
        showChatIcon
        menuSurface="pinned"
        ariaLabel="Pinned projects"
      />
    </CollapsibleNavSection>
  )
}
